import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "business-page"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "advantages"
};
const _hoisted_4 = {
  class: "success-cases"
};
const _hoisted_5 = {
  class: "cases"
};
const _hoisted_6 = {
  class: "card-inner"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "card-face card-back"
};
const _hoisted_9 = {
  class: "card-icon"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "card-title"
};
const _hoisted_12 = {
  class: "card-content"
};
const _hoisted_13 = {
  class: "case-title"
};
const _hoisted_14 = {
  class: "dialog-footer"
};
const _hoisted_15 = {
  class: "business-cooperation"
};
const _hoisted_16 = {
  class: "scroll-container"
};
const _hoisted_17 = {
  class: "scroll-row row-1"
};
const _hoisted_18 = {
  class: "scroll-content"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "scroll-row row-2"
};
const _hoisted_22 = {
  class: "scroll-content"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  class: "scroll-row row-3"
};
const _hoisted_26 = {
  class: "scroll-content"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[7] || (_cache[7] = _createElementVNode("h1", null, "我们的优势", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.advantages, (advantage, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "advantage-item"
    }, [_cache[6] || (_cache[6] = _createElementVNode("i", {
      class: "icon fa fa-arrows-alt fa-spin"
    }, null, -1)), _createElementVNode("span", null, _toDisplayString(advantage), 1)]);
  }), 128))])]), _createElementVNode("div", _hoisted_4, [_cache[9] || (_cache[9] = _createElementVNode("h1", null, "成功案例", -1)), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cases, (caseItem, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "case-item"
    }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
      src: caseItem.image,
      alt: "案例图片",
      class: "case-image card-face card-front"
    }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
      style: {
        "width": "30px",
        "height": "30px"
      },
      src: caseItem.icon
    }, null, 8, _hoisted_10)]), _createElementVNode("div", _hoisted_11, _toDisplayString(caseItem.contenttitle), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(caseItem.content), 1)])]), _createElementVNode("p", _hoisted_13, _toDisplayString(caseItem.title), 1)]);
  }), 128))]), _createVNode(_component_el_button, {
    type: "primary",
    class: "cooperation-button",
    onClick: _cache[0] || (_cache[0] = $event => $data.showForm = true)
  }, {
    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" 合作申请 ", -1)]))]),
    _: 1
  })]), _createVNode(_component_el_dialog, {
    title: "合作申请",
    modelValue: $data.showForm,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.showForm = $event),
    onOpen: $options.resetForm,
    width: "30%",
    class: "fycop"
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_14, [_createVNode(_component_el_button, {
      onClick: _cache[4] || (_cache[4] = $event => $data.showForm = false)
    }, {
      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("取消", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.submitForm
    }, {
      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("提交", -1)]))]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      ref: "form",
      model: $data.cooperationForm,
      rules: $data.rules,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "企业名称",
        prop: "name"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.cooperationForm.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.cooperationForm.name = $event),
          placeholder: "请输入企业名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "Logo"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          action: "#",
          "before-upload": $options.beforeLogoUpload,
          "show-file-list": false
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary"
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("点击上传", -1)]))]),
            _: 1
          }), _cache[11] || (_cache[11] = _createElementVNode("div", {
            class: "el-upload__tip"
          }, "请上传企业 Logo", -1))]),
          _: 1
        }, 8, ["before-upload"]), $data.cooperationForm.logo ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          src: $data.cooperationForm.logo,
          class: "logo-preview",
          "preview-src-list": [$data.cooperationForm.logo],
          "initial-index": 0,
          fit: "cover"
        }, null, 8, ["src", "preview-src-list"])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "公司官网",
        prop: "website"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.cooperationForm.website,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.cooperationForm.website = $event),
          placeholder: "请输入公司官网链接"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "公司简介"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.cooperationForm.introduction,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.cooperationForm.introduction = $event),
          placeholder: "请输入公司简介"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue", "onOpen"]), _createElementVNode("div", _hoisted_15, [_cache[14] || (_cache[14] = _createElementVNode("h1", null, "技术栈选择", -1)), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.companies, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "company-item"
    }, [_createElementVNode("img", {
      style: {
        "width": "30px"
      },
      src: require('./svg' + item)
    }, null, 8, _hoisted_19)]);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.companies, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index + $data.companies.length,
      class: "company-item"
    }, [_createElementVNode("img", {
      style: {
        "width": "30px"
      },
      src: require('./svg' + item)
    }, null, 8, _hoisted_20)]);
  }), 128))])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.companies, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "company-item"
    }, [_createElementVNode("img", {
      style: {
        "width": "30px"
      },
      src: require('./svg' + item)
    }, null, 8, _hoisted_23)]);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.companies, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index + $data.companies.length,
      class: "company-item"
    }, [_createElementVNode("img", {
      style: {
        "width": "30px"
      },
      src: require('./svg' + item)
    }, null, 8, _hoisted_24)]);
  }), 128))])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.companies, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "company-item"
    }, [_createElementVNode("img", {
      style: {
        "width": "30px"
      },
      src: require('./svg' + item)
    }, null, 8, _hoisted_27)]);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.companies, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index + $data.companies.length,
      class: "company-item"
    }, [_createElementVNode("img", {
      style: {
        "width": "30px"
      },
      src: require('./svg' + item)
    }, null, 8, _hoisted_28)]);
  }), 128))])])])])]);
}